import {
  Button,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  CircularProgress,
} from "@mui/material";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { api } from "../../../redux/api";
import { treeActions } from "../../../redux/slices/treeSlice";
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import TPCheckbox from "../../TemplateProperties/TPCheckbox";
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import { newTemplateActions } from "../../../redux/slices/newTemplateSlice";


const nodeIconOld = {
  inboundTemplate: <span className="GET_DATA margin-right-4"></span>, 
  outboundTemplate: <span className="SEND_DATA margin-right-4"></span>, 
  workflow: <span className="CALL_WORKFLOW margin-right-4"></span>,
  workflowGroup: <span className="RECORD margin-right-4"></span>,
}

function DragDropTemplate(props) {
  const { openModal, toggle, template, wfg, destinationWfg, draggedTempInfo, draggedNode } = props;
  const { t } = useTranslation();
  const errorRef = useRef();
  const overwriteErrorRef = useRef(null)
  const dispatch = useDispatch();
  const [errorModal, setErrorModal] = useState(false);
  const [isUserSpace, setIsUserSpace] = useState(true);
  const [isServer, setIsServer] = useState(false);
  const [checkboxDisabled, setCheckboxDisabled] = useState({
    server: true,
    userSpace: true
  });
  const [error, setError] = useState("");
  const [action, setAction] = useState("");
  const [isMoveLoading, setIsMoveLoading] = useState(false);
  const [isCopyLoading, setIsCopyLoading] = useState(false);
  const [isOverwriteLoading, setIsOverwriteLoading] = useState(false)
  const { account } = useSelector((state) => state.queryParams);
  const parentScreen = useContext(ParentScreenCtx);
  const selectedNode = useSelector(
    (state) =>
      state.treeData[parentScreen].leftTree.tree.body
        .selectedNode
  );
  const currentScreen = useSelector(state => state.treeData.currentScreen)
  const errorMessage = t("WRN_FILE_ALREADY_EXISTS_");
  const dispatchTree = currentScreen === 'inbound' ? 'getInboundTemplateList' : currentScreen === 'outbound' ? 'getOutboundTemplateList' : 'getWorkflows'
  const moveEndPoint = currentScreen === 'inbound' ? 'moveInboundTemplate' : currentScreen === 'outbound' ? 'moveOutboundTemplate' : 'moveWorkflowTemplate'
  const copyEndPoint = currentScreen === 'workflow' ? 'copyWorkflowTemplate' : 'copyInboundTemplate'
  const errorModalHandler = () => {
    setErrorModal(!errorModal);
    toggle();
  };

  const fetchNewTemplate = (workflowGroup, template) => {
    //define endpoint based on screen
    let dispatchType = parentScreen === 'outbound' ?
      'getOutboundTemplate' : parentScreen === 'workflow' ?
        'getWorkflowTree' : 'getInboundTemplate';

    dispatch(treeActions.setRightTreeLoading({screen: parentScreen, data: true}));
    dispatch(treeActions.setRightTreePath({
      screen: parentScreen,
      workflowGroup: workflowGroup, 
      template: template
    }));
    dispatch(api.endpoints[dispatchType].initiate({
      account,
      workflowGroupName: (workflowGroup),
      templateName: template
    }, {
      subscribe: false, forceRefetch: true
    }));
  }

  const handleMoveClick = () => {
    setAction("move");
    setIsMoveLoading(true);
  
    if (isServer || isUserSpace) {
      dispatch(
        api.endpoints[moveEndPoint].initiate({
          account,
          sourceWfg: encodeURIComponent(wfg),
          destiationWfg: encodeURIComponent(destinationWfg),
          templateName: encodeURIComponent(template),
          is_overwrite: "",
          is_userspace: isUserSpace,
          is_server: isServer,
        })
      )
        .then((response) => {
          // Check if there's an error in the response
          if (response.error) {
            errorRef.current.textContent =
              response?.message || response?.data?.message || t("BOX_MSG_GENERAL_ERROR");
            return;
          }
  
          if (response.data.current_state === "SUCCESS") {
            dispatch(newTemplateActions.setShowAlert(true));
            dispatch(newTemplateActions.setAlertMessage(response.data.message));
  
            dispatch(
              treeActions.setLeftTreeContextActionValue({
                screen: parentScreen,
                data: {
                  name: encodeURIComponent(template),
                  workflowGroup: destinationWfg,
                },
              })
            );
  
            dispatch(
              api.endpoints[dispatchTree].initiate(
                { account },
                { subscribe: false, forceRefetch: true }
              )
            );
  
            setTimeout(() => fetchNewTemplate(encodeURIComponent(destinationWfg), template), 0);
            toggle();
          } else {
            const showModal = 
            response.data.message.includes(t('BOX_TEM_NM_ALREADY_EXISTS__CHOOSE_ANOTHER')) ||
            response.data.message.includes(t('BOX_WF_NM_ALREADY_EXISTS__CHOOSE_ANOTHER'));

            const error = showModal ? errorMessage : response.data.message;
            
            if (showModal) {
              setError(error);
              setErrorModal(true);
            } else {
              errorRef.current.textContent = error;
            }
          }
        })
        .catch((error) => {
          errorRef.current.textContent = error?.message || t("BOX_MSG_GENERAL_ERROR");
        })
        .finally(() => {
          setIsMoveLoading(false);
        });
    }
  };
  
  const handleCopyClick = () => {
    setAction("copy");
    setIsCopyLoading(true)
    if (isServer || isUserSpace) {
        dispatch(
          api.endpoints[copyEndPoint].initiate({
            account,
            sourceAccount: account,
            sourceWorkflowName: wfg,
            sourceTemplateName: template,
            destinationWorkflowName: destinationWfg,
            newTemplateName: template,
            is_overwrite: "",
            is_userspace: isUserSpace,
            is_server: isServer,
            is_inbound: currentScreen === 'inbound'
          },{forceRefetch: true})
        ).then((response) => {
          if(response.error){
            errorRef.current.textContent = response?.error?.message || t('BOX_MSG_GENERAL_ERROR');
            return;
          }
          if (response.data.current_state === "SUCCESS") {
            dispatch(newTemplateActions.setShowAlert(true));
            dispatch(newTemplateActions.setAlertType('success'))
            dispatch(newTemplateActions.setAlertMessage(response.data.message))
            dispatch(
              treeActions.setLeftTreeContextActionValue({
                screen: parentScreen,
                data: {
                  name: template,
                  workflowGroup: destinationWfg,
                },
              })
            );
            dispatch(
              api.endpoints[dispatchTree].initiate(
                { account },
                { subscribe: false,forceRefetch: true }
              )
            );
            setTimeout(() => {
              fetchNewTemplate(encodeURIComponent(destinationWfg), template);
            }, 0);
            
            toggle();
          } else {
            const showModal = 
            response.data.message.includes(t('BOX_TEM_NM_ALREADY_EXISTS__CHOOSE_ANOTHER')) ||
            response.data.message.includes(t('BOX_WF_NM_ALREADY_EXISTS__CHOOSE_ANOTHER'));
            const error = showModal ? errorMessage : response.data.message;
            
            if(showModal) {
              setError(error);
              setErrorModal(true);
            } else{
              errorRef.current.textContent = error;
            }
          }
        })
        .catch(error => {
          setIsCopyLoading(false);
          errorRef.current.textContent = error.message ||  t('BOX_MSG_GENERAL_ERROR')
        })
        .finally(() => {
          setIsCopyLoading(false)
        })
     
    }
  };
  const handleCancelClick = () => {
    toggle();
  };
  const handleYesClick = (act) => {
    setIsOverwriteLoading(true)
    if (isServer || isUserSpace) {
      if (act === "copy") {
        dispatch(
          api.endpoints[copyEndPoint].initiate({
            account,
            sourceAccount: account,
            sourceWorkflowName: encodeURIComponent(wfg),
            sourceTemplateName: template,
            destinationWorkflowName: destinationWfg,
            newTemplateName: template,
            is_overwrite: "yes",
            is_userspace: isUserSpace,
            is_server: isServer,
            is_inbound: currentScreen === 'inbound'
          })
        ).then((response) => {
          if(response.error){
            overwriteErrorRef.current.textContent = response?.error?.message || t('BOX_MSG_GENERAL_ERROR');
            return;
          }
          if (response.data.current_state === "SUCCESS") {
            dispatch(newTemplateActions.setShowAlert(true));
            dispatch(newTemplateActions.setAlertType('success'))
            dispatch(newTemplateActions.setAlertMessage(response.data.message))
            dispatch(
              treeActions.setLeftTreeContextActionValue({
                screen: parentScreen,
                data: {
                  name: template,
                  workflowGroup: destinationWfg,
                },
              })
            );
            dispatch(
              api.endpoints[dispatchTree].initiate(
                { account },
                { subscribe: false, forceRefetch: true }
              )
            );
            setTimeout(() => {
              fetchNewTemplate(destinationWfg, template);
            }, 0);
            toggle();
          } else {
            setError(response.data.message);
            setErrorModal(true);
            overwriteErrorRef.current.textContent = response.data.message;
          }
        })
        .catch((error) => {
          overwriteErrorRef.current.textContent = error || t('BOX_MSG_GENERAL_ERROR')
        })
        .finally(() => {
          setIsOverwriteLoading(false)
        })
      } else if (act === "move") {
        dispatch(
          api.endpoints[moveEndPoint].initiate({
            account,
            sourceWfg: encodeURIComponent(wfg),
            destiationWfg: encodeURIComponent(destinationWfg),
            templateName: template,
            is_overwrite: "yes",
            is_userspace: isUserSpace,
            is_server: isServer
          })
        ).then((response) => {
          if(response.error){
            overwriteErrorRef.current.textContent = response?.error?.message || t('BOX_MSG_GENERAL_ERROR');
            return;
          }
          if (response.data.current_state === "SUCCESS") {
            dispatch(newTemplateActions.setShowAlert(true));
            dispatch(newTemplateActions.setAlertMessage(response.data.message))
            dispatch(
              treeActions.setLeftTreeContextActionValue({
                screen: parentScreen,
                data: {
                  name: template,
                  workflowGroup: encodeURIComponent(destinationWfg),
                },
              })
            );
            dispatch(
              treeActions.setLeftTreeSelectedNode({
                screen: parentScreen,
                type: "body",
                data: {
                  ...selectedNode,
                  title: template,
                  workflowGroup: (destinationWfg),
                },
              })
            );
            dispatch(
              api.endpoints[dispatchTree].initiate(
                { account },
                { subscribe: false,forceRefetch: true }
              )
            );
            setTimeout(() => {
              fetchNewTemplate(destinationWfg, template);
            }, 0);
            toggle();
          } else {
            setError(response.data.message);
            setErrorModal(true);
            overwriteErrorRef.current.textContent = response.data.message;
          }
        })
        .catch(error => {
          setIsCopyLoading(false);
          overwriteErrorRef.current.textContent = error.message ||  t('BOX_MSG_GENERAL_ERROR')
        })
        .finally(() => {
          setIsOverwriteLoading(false)
        })
      }
    }
  };

  useEffect(() => {
    if (errorRef?.current && (isServer || isUserSpace)) {
      errorRef.current.textContent = ''
    }
  }, [isUserSpace, isServer])

  useEffect(() => {
    const { location } = draggedNode;
    if (location === 'server') {
      setIsServer(true);
      setIsUserSpace(false);
      setCheckboxDisabled({server: false, userSpace: true});
    } else if (location === 'both') {
      setIsServer(true);
      setIsUserSpace(true);
      setCheckboxDisabled({server: false, userSpace: false});
    } else {
      setIsUserSpace(true);
      setIsServer(false);
      setCheckboxDisabled({server: true, userSpace: false});
    }
  }, [draggedNode]);

  return (
    <>
      <Dialog open={openModal} maxWidth='sm'>
        <DialogTitle className="dialog-header padding-12">
          <div className="title">{t("BOX_CONFIRM")}</div>
        </DialogTitle>
        <DialogContent className="modal-content" dividers style={{width: 'unset'}}>
          <div>{t('ASK_MOVE_TEMPLATE_TO_WORKFLOW_GROUP')}</div>
          <div className="margin-top-12"><strong>{t('MOVE_TEMPLATE_SAVE_WARNING')}</strong></div>
          <div className="flex flex-wrap">
            <div className="flex align-center">{nodeIconOld[draggedTempInfo.node.type]}<strong>{template}</strong></div>
            <div className="margin-12 flex align-center"><ArrowRightAltIcon /></div>
            <div className="flex align-center">{nodeIconOld['workflowGroup']}<strong>{destinationWfg}</strong></div>
          </div>
          {/* <div dangerouslySetInnerHTML={{ __html: `${t(body)} ${t(warning)} ${t(foot)}` }} /> */}
        </DialogContent>
        <DialogActions>
          <div className="flex justify-start width-100">
            <TPCheckbox
              label={t('USERSPACE')}
              checked={isUserSpace}
              disabled={checkboxDisabled.userSpace}
              handleCheck={(checked) => {
                setIsUserSpace(checked);
              }}
            />
            <TPCheckbox
              label={t('SERVER')}
              disabled={checkboxDisabled.server}
              checked={isServer}
              handleCheck={(checked) => {
                setIsServer(checked);
              }}
            />
          </div>
          <Button disabled={!isServer && !isUserSpace && isMoveLoading} variant="outlined" size='small' color="primary" onClick={handleMoveClick}>
            {isMoveLoading ? <CircularProgress size={"20px"}/>: t("BTN_MOVE")}
          </Button>
          <Button disabled={!isServer && !isUserSpace && isCopyLoading} variant="outlined" size='small' color="primary" onClick={handleCopyClick}>
            {isCopyLoading ? <CircularProgress size={"20px"} /> : t("MNU_COPY")}
          </Button>
          <Button
            variant="outlined"
            color="primary"
            size="small"
            onClick={handleCancelClick}>
            {t("CANCEL")}
          </Button>
        </DialogActions>
        <p className="error padding-8" ref={errorRef}></p>
      </Dialog>

      {/* Error Modal */}
      <Dialog
        open={errorModal}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description">
        <DialogTitle className="dialog-header">
          <div className="title">{t("BOX_CONFIRM")}</div>
        </DialogTitle>
        <DialogContent dividers>{error}</DialogContent>
        <DialogActions>
          <Button
            size="small"
            color="primary"
            disabled={isOverwriteLoading}
            onClick={() => {
              handleYesClick(action);
            }}
            variant="outlined">
            {isOverwriteLoading ? <CircularProgress size={"20px"} /> : t("YES")}
          </Button>
          <Button size="small" onClick={errorModalHandler} variant={"outlined"}>
            {t("NO")}
          </Button>
        </DialogActions>
        <p className= 'error padding-8' ref={overwriteErrorRef}></p>
      </Dialog>
    </>
  );
}

export default DragDropTemplate;
